export const PROPERTIES = 'Properties'
export const CLEAR = 'Clear'
